'use strict'

import '../scss/site.scss'
import {Backend} from '@common/backend'
import {Tracking, TrackingEvent} from '@common/tracking'
import {setPersonProperties} from '@common/yougile-analytics'
import {CommonController} from './common'
import {AboutController} from './site-page-about'
import {CalcController} from './site-page-calc'
import {DownloadController} from './site-page-download'
import {IndexController} from './site-page-index'
import {PricesController} from './site-page-prices'
import {ProductController} from './site-page-product'
import {TrainingController} from './site-page-training'
import {SubmissionsController} from './submissions'

export const initAnalytics = async (): Promise<void> => {
  await Backend.init()
  Tracking.initialize()
  Tracking.enable()
  await setPersonProperties()
  Tracking.send(TrackingEvent.landingPageOpened, {
    pathName: location.pathname
  })
}

void initAnalytics()

CommonController.start()
SubmissionsController.start()

if (window.location.pathname === '/' || window.location.pathname === '/index') {
  IndexController.init()
}
if (window.location.pathname === '/product') {
  ProductController.findDuplicateSections()
}
if (window.location.pathname === '/training') {
  TrainingController.start()
}
if (window.location.pathname === '/prices') {
  PricesController.init()
}
if (window.location.pathname === '/download') {
  DownloadController.init()
}
if (window.location.pathname === '/calc') {
  CalcController.init()
}
if (window.location.pathname === '/about') {
  AboutController.usersCounter()
}
